import { withRouter } from "react-router-dom";
import styled, { css, keyframes } from "styled-components";
import defaultTheme from "@material-ui/core/styles/defaultTheme";
import { withTheme } from "@material-ui/core/styles";
import position from "../Page/position";
import focus from "../Page/focus";
import focusShifted from "../Page/focusShifted";

const breath = keyframes`
  0% {
    transform:scale(1.0);
  }
  50% {
    transform:scale(2.0);
  }
  100% {
    transform:scale(1.0);
  }
`;

const fade = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const MainRing = styled.div`
  ${position}
  ${({ theme }) => css`
    background-color: ${theme.palette.secondary.main};
  `}
  ${({ open, location: { pathname } }) =>
    pathname === "/" &&
    css`
      ${focus}
      ${open && focusShifted}
      ${[defaultTheme.breakpoints.up("lg")]} {
        ${focusShifted}
      }
    `};
  opacity: 0;
  animation: ${fade} 1100ms cubic-bezier(0.4, 0, 0.2, 1) forwards 550ms,
    ${breath} 6s cubic-bezier(0.4, 0, 0.2, 1) infinite 225ms;
`;

export default withRouter(withTheme(MainRing));
